import {
  verifyMonad_default
} from "./chunk-RXIADIQN.mjs";

// src/monet-utils/verifyImmutableRecord.ts
function verifyImmutableRecord(sourceRecord) {
  const keys = Object.keys(sourceRecord.toObject());
  return keys.reduce((acc, key) => acc.update(`${key}`, verifyMonad_default), sourceRecord);
}
var verifyImmutableRecord_default = verifyImmutableRecord;

export {
  verifyImmutableRecord_default
};
//# sourceMappingURL=chunk-3FP3MTYL.mjs.map